!customElements.get('op-internal-scroll-banner') && customElements.define('op-internal-scroll-banner', class extends HTMLElement {
    connectedCallback () {
        this.threshold = parseFloat(this.dataset.threshold || "0");
        this.tabControls = this.querySelector("[data-tab-controls]");
        this.blocks = this.querySelectorAll("[data-block-id]");
        this.blockPictures = this.querySelectorAll("[data-block-image]");
        this.blockTriggers = this.querySelectorAll("[data-block-trigger]");

        this.observer = new IntersectionObserver(this.intersectionCallback.bind(this), {
            root: null,
            rootMargin: "0px",
            threshold: this.threshold
        });

        this.blocks.forEach(block => {
            this.observer.observe(block);
        });

        this.blockTriggers.forEach(trigger => {
            trigger.addEventListener("click", this.handleBlockTriggerClick);
        });
    }

    desconnectedCallback () {
        this.observer.disconnect();

        this.blockTriggers.forEach(trigger => {
            trigger.removeEventListener("click", this.handleBlockTriggerClick);
        });
    }

    handleBlockTriggerClick = (event) => {
        const targetBlock = event.currentTarget.dataset.blockTrigger;

        this.blocks.forEach(block => {
            if (block.dataset.blockId === targetBlock) {
                block.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        });
    }

    intersectionCallback (entries = []) {
        entries.forEach(entry => {
            const blockId = entry.target?.dataset?.blockId;

            if (entry.isIntersecting && blockId) {
                this.showImage(blockId);
            }
        });
    }

    showImage (blockId) {
        this.blockPictures.forEach(pict => {
            pict.style.opacity = pict.dataset.blockImage === blockId ? "1" : "0";
        });

        this.blockTriggers.forEach(trigger => {
            const isCurrent = trigger.dataset.blockTrigger === blockId;
            trigger.ariaSelected = isCurrent;
            trigger.toggleAttribute("data-current", isCurrent);
        });
    }
});